(function () {
    'use strict';

    angular
        .module('app')
        .component('concertAddRemoveTour', {
            templateUrl: 'components/directives/concert_add_remove_tour/view.concert_add_remove_tour.html',
            bindings: {
                concert: '<',
                tours: '<',
                onClose: '&',
                onSave: '&'
            },
            controller: ['$http', '$q', 'tourHelper', ConcertAddRemoveTourController]
        });


    function ConcertAddRemoveTourController($http, $q, tourHelper) {
        const ctrl = this;
        ctrl.isSaving = false;
        ctrl.selectedTourId = undefined;
        ctrl.tours = [];
        ctrl.hasUnselectableTour = false;

        ctrl.$onInit = function () {
            ctrl.selectedTourId = ctrl.concert.tour_id;
            ctrl.tours = ctrl.tours.map(tour => ({
                id: tour.id,
                name: tour.name,
                selectable: tourHelper.isConcertValidForTour(tour, ctrl.concert)
            }));
            ctrl.hasUnselectableTour = ctrl.tours.some(tour => !tour.selectable);
        }

        ctrl.close = function () {
            ctrl.onClose();
        };

        ctrl.save = async function () {
            try {
                ctrl.isSaving = true;
                await $q.when($http.put(`api/concerts/${ctrl.concert.concert_id}/tour`, { tour_id: ctrl.selectedTourId || null }));
                ctrl.onSave();
            } finally {
                ctrl.isSaving = false;
            }
        };

        ctrl.toggleSelectedTour = function (tour) {
            if (ctrl.selectedTourId === tour.id) {
                ctrl.selectedTourId = null;
            } else {
                ctrl.selectedTourId = tour.id;
            }
        }
    }
})();